module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-dealing-task"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("任务来源:")]), _vm._v(" "), _c('span', {
    staticClass: "select-box",
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.choose(0)
      }
    }
  }, [_vm._v("执行任务")]), _vm._v(" "), _c('span', {
    staticClass: "select-box",
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.choose(1)
      }
    }
  }, [_vm._v("派发任务")])]), _vm._v(" "), _c('listWrap', {
    attrs: {
      "data": _vm.data,
      "config": _vm.config,
      "keyStatus": _vm.key_status
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('z-pagination', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "getPage": _vm.refresh
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f4e64ce6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/task/page-dealing.vue
// module id = 796
// module chunks = 1